import {createContext, type Context, useContext} from 'react'

const AiChatContext: Context<null> = createContext(null)
export const useAiChatContext = () => useContext(AiChatContext)
export default AiChatContext
